import styles from './beta-label.module.scss';

export default function BetaLabel() {
  return <span className={styles.betaLabel}>BETA</span>;
}
